// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dynamic-keyboard {
  position: fixed;
  width: 100%;
  max-width: 100%;
  z-index: 999;
  transition: bottom 0.3s ease, opacity 0.3s ease;
  background: #f0f0f0;
}

.dynamic-keyboard.slide-up {
  opacity: 1;
}

.dynamic-keyboard.slide-down {
  opacity: 0;
}

/* Reduce key size */
.hg-theme-default .hg-button {
  font-size: 18px !important;
  height: 36px !important;
}

/* Reduce row spacing */
.hg-theme-default .hg-row {
  margin-bottom: 4px;
}

/* Optional rounded keys */
.hg-theme-default .hg-button {
  border-radius: 6px;
}

/* Smooth slide animation */
.dynamic-keyboard {
  transition: bottom 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/app/Shared/Pages/dynamicSlidingKeyboard/DynamicKeyboard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,4BAA4B;AAC9B","sourcesContent":[".dynamic-keyboard {\n  position: fixed;\n  width: 100%;\n  max-width: 100%;\n  z-index: 999;\n  transition: bottom 0.3s ease, opacity 0.3s ease;\n  background: #f0f0f0;\n}\n\n.dynamic-keyboard.slide-up {\n  opacity: 1;\n}\n\n.dynamic-keyboard.slide-down {\n  opacity: 0;\n}\n\n/* Reduce key size */\n.hg-theme-default .hg-button {\n  font-size: 18px !important;\n  height: 36px !important;\n}\n\n/* Reduce row spacing */\n.hg-theme-default .hg-row {\n  margin-bottom: 4px;\n}\n\n/* Optional rounded keys */\n.hg-theme-default .hg-button {\n  border-radius: 6px;\n}\n\n/* Smooth slide animation */\n.dynamic-keyboard {\n  transition: bottom 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
